import {GetQuoteType as GetQuoteDesktopType} from 'desktop/pages/cart/store/reducers/quoteItems/quoteItems';
import {CartItemAccessoryType} from 'desktop/pages/cart/types';
import {CartItemEyeglassesMobileType, GetQuoteType} from 'mobile/actions/checkout/checkout';

/**
 * Type check.
 *
 * @param {CartItemType} product - Quote item.
 * @param {Array<string>} typeList - Type list.
 * @returns {boolean} Type check result.
 */
export const typeCheck = (
    product: GetQuoteType['quoteItems'][0] | GetQuoteDesktopType['quoteItems'][0],
    typeList: Array<string>,
): boolean => typeList.includes(product.type);

/**
 * Check product type for glasses
 *
 * @param {CartItemType} product - Quote item.
 * @returns {boolean} Type check result.
 */
export const isGlasses = (
    product: GetQuoteType['quoteItems'][0] | GetQuoteDesktopType['quoteItems'][0],
): product is CartItemEyeglassesMobileType =>
    typeCheck(product, ['sunglasses', 'eyeglasses', 'upgrade']);

/**
 * Check product type for accessory
 *
 * @param {CartItemType} product - Quote item.
 * @returns {boolean} Type check result.
 */
export const isAccessory = (
    product: GetQuoteType['quoteItems'][0],
): product is CartItemAccessoryType => typeCheck(product, ['accessories']);
